import { IdentifierType } from './types'

/**
 * Enumerates supported identifier types by each supported country (2-letter ISO code).
 *
 * When we open a new market we should look at exposing the backend API over graphql
 */
export const supportedIdentifierTypes: { [key: string]: IdentifierType[] } = {
  es: [
    // TODO: Grow over time
    {
      value: 'dni',
      label: 'DNI',
    },
    {
      value: 'nie',
      label: 'NIE',
    },
    {
      value: 'passport',
      label: 'Passport',
    },
  ],
}
